import axios, { AxiosResponse } from "axios";

import { UPDATESURL, LOCATIONCHECK } from "./constants";
import { removeAllCookies } from "../pages/Finupdate/cookies";
import { getCookie } from "./cookies";

const axiosInterceptor = axios.create({
  baseURL: UPDATESURL,
});
const axiosInterceptorLocationCheck = axios.create({
  baseURL: LOCATIONCHECK,
});
axiosInterceptor.interceptors.request.use(
  async (req) => {
    const token = getCookie("access_token");
    const userid = getCookie("userId");
    const deviceId = getCookie("deviceId");
    const source = getCookie("source") ? getCookie("source") : "WEB";

    req.headers.Authorization = `userId=${userid};deviceId=${deviceId};source=${source};finupdate_token=${token}`;
    return req;
  },
  (error) => Promise.reject(error)
);

axiosInterceptor.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response ? err.response.status : null;
    if (status === 401) {
      handleLogout();
    }
    return Promise.reject(err);
  }
);
const handleLogout = () => {
  removeAllCookies();
  window.location.href = "/";
};

export const LocationCheckAPICall = (ip_address: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptorLocationCheck
      .get(`/v1/api/ip/ip_location_check`, {
        params: { ip_address: ip_address },
      })
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};

export const SaveIpAddressAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/api/V1/login/save_ip_address/`, requestBody, {})
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const stageDetailsAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/ekyc/stagedetails/`, requestBody, {})
      .then((response: AxiosResponse) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const GetProfileDetailsCommonAPICall = () => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/v1/api/common/profileDetails`, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
